import { render } from "./ResetPassword.vue?vue&type=template&id=876b60c4"
import script from "../js/reset-password.js?vue&type=script&lang=js&external"
export * from "../js/reset-password.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__